/**
 * Flatten nested object into `separator` connected key
 */
export const flattenObject = (ob, separator = '.') => {
  const toReturn = {}

  for (const i in ob) {
    // eslint-disable-next-line
    if (!ob.hasOwnProperty(i)) continue

    if (typeof ob[i] == 'object' && ob[i] !== null) {
      const flatObject = flattenObject(ob[i])
      for (const x in flatObject) {
        // eslint-disable-next-line
        if (!flatObject.hasOwnProperty(x)) continue

        toReturn[i + separator + x] = flatObject[x]
      }
    } else {
      toReturn[i] = ob[i]
    }
  }
  return toReturn
}
